var BxfAccordionExpansionPanelTypeEnum;
(function (BxfAccordionExpansionPanelTypeEnum) {
    BxfAccordionExpansionPanelTypeEnum["STANDARD"] = "standard";
    BxfAccordionExpansionPanelTypeEnum["LARGE"] = "large";
})(BxfAccordionExpansionPanelTypeEnum || (BxfAccordionExpansionPanelTypeEnum = {}));

class BxfAccordionExpansionPanelConstants {
    static COMPONENT_NAME = 'bxf-accordion-expansion-panel';
    static STRING = {
        BXF_ACCORDION_EXPANSION_PANEL_HEADER_EXPANDED: 'bxf-accordion-expansion-panel__header--expanded',
        BXF_ACCORDION_EXPANSION_PANEL_CONTAINER_EXPANDED: 'bxf-accordion-expansion-panel__container--expanded',
        BXF_ACCORDION_EXPANSION_PANEL_WRAPPER_DIV: 'bxf-accordion-expansion-panel-div-wrapper',
        BXF_ACCORDION_EXPANSION_PANEL_CONTAINER: 'bxf-accordion-expansion-panel__container',
        BXF_ACCORDION_EXPANSION_PANEL_CONTAINER_BORDER_LESS: 'bxf-accordion-expansion-panel__container--border-less',
        BXF_ACCORDION_EXPANSION_PANEL_CONTAINER_BOTTOM_BORDER_LESS: 'bxf-accordion-expansion-panel__container--bottom-border-less',
        BXF_ACCORDION_EXPANSION_PANEL_CONTAINER_LARGE: 'bxf-accordion-expansion-panel__container--large',
        BXF_ACCORDION_EXPANSION_PANEL_CONTAINER_BOTTOM_BORDER: 'bxf-accordion-expansion-panel__container--bottom-border',
        BXF_ACCORDION_EXPANSION_PANEL_CONTAINER_OPEN_LEFT_BORDER: 'bxf-accordion-expansion-panel__container-open--border-left',
        BXF_ACCORDION_EXPANSION_PANEL_HEADER: 'bxf-accordion-expansion-panel__header',
        BXF_ACCORDION_EXPANSION_PANEL_HEADER_LARGE: 'bxf-accordion-expansion-panel__header--large',
        BXF_ACCORDION_EXPANSION_PANEL_HEADER_BADGE: 'bxf-accordion-expansion-panel__header-badge',
        BXF_ACCORDION_EXPANSION_PANEL_HEADER_LINE: 'bxf-accordion-expansion-panel__header-line',
        BXF_ACCORDION_EXPANSION_PANEL_HEADER_LABEL: 'bxf-accordion-expansion-panel__header-label',
        BXF_ACCORDION_EXPANSION_PANEL_HEADER_LABEL_NORMAL: 'bxf-accordion-expansion-panel__header-label--normal',
        BXF_ACCORDION_EXPANSION_PANEL_HEADER_SECONDARY_LABEL: 'bxf-accordion-expansion-panel__header-secondary-label',
        BXF_ACCORDION_EXPANSION_PANEL_HEADER_BUTTON: 'bxf-accordion-expansion-panel__header-button',
        BXF_ACCORDION_EXPANSION_PANEL_HEADER_COMPACT: 'bxf-accordion-expansion-panel__header--compact',
        BXF_ACCORDION_EXPANSION_PANEL_CONTENT: 'bxf-accordion-expansion-panel__content',
        BXF_ACCORDION_EXPANSION_PANEL_CONTENT_COMPACT: 'bxf-accordion-expansion-panel__content--compact',
        BXF_ACCORDION_EXPANSION_PANEL_CONTENT_LARGE: 'bxf-accordion-expansion-panel__content--large',
        BXF_ACCORDION_EXPANSION_PANEL_CONTENT_INNER: 'bxf-accordion-expansion-panel__content--inner',
        DISABLED: 'disabled',
        CONTAINER_BORDER: 'container-border',
        EXPAND: 'expand',
        HEADER_EXPAND: 'header-expand',
        HEADER_ACTION: 'header-action',
        SIDE_NAV_ICON_HEADER: 'bxf-side-nav__header--padding',
        SIDE_NAV_HEADER: 'bxf-side-nav__title--padding',
    };
}

class BxfAccordionConstants {
    static STRING = {
        BXF_ACCORDION_EXPANSION_PANEL: 'BXF-ACCORDION-EXPANSION-PANEL',
        BXF_ACCORDION_EXPANSION_PANEL_DIV: 'bxf-accordion-expansion-panel',
        ERROR_MESSAGE: 'Tags other than bxf-accordion-expansion-panel are not supported within bxf-accordion',
        TEXT: '#text',
        BORDER: 'bxf-accordion__border',
        BXF_EXPANSION_PANEL_CONTAINER: 'bxf-accordion-expansion-panel__container',
        BXF_EXPANSION_PANEL_HEADER: 'bxf-accordion-expansion-panel__header',
        FACETED_FILTER_SUFFIX: '-faceted-filter',
        // avoid circular dependency with faceted filter
        FACETED_FILTER_TAGNAME: 'bxf-faceted-filter',
        FACETED_FILTER_OPTION_TAGNAME: 'bxf-faceted-filter-option',
        BUTTON: 'button',
    };
}

export { BxfAccordionExpansionPanelTypeEnum as B, BxfAccordionExpansionPanelConstants as a, BxfAccordionConstants as b };
